import type { ReactNode } from 'react';

import { ReactComponent as FamilyLink } from './assets/FamilyLink.svg';
import { ReactComponent as FeedbackIcon } from './assets/Feedback-icon.svg';
import { ReactComponent as MenuFoldOutlined } from './assets/MenuFoldOutlined.svg';
import { ReactComponent as MenuUnfoldOutlined } from './assets/MenuUnfoldOutlined.svg';
import { ReactComponent as PreviewIcon } from './assets/Preview.svg';
import { ReactComponent as CaretDownDark } from './assets/caret-down-dark.svg';
import { ReactComponent as CaretDown } from './assets/caret-down.svg';
import { ReactComponent as DBAssessment } from './assets/db-assessment.svg';
import { ReactComponent as DBAward } from './assets/db-award.svg';
import { ReactComponent as DBFIMStore } from './assets/db-fim-store.svg';
import { ReactComponent as DBFocus } from './assets/db-focus.svg';
import { ReactComponent as DBGlobal } from './assets/db-global.svg';
import { ReactComponent as DBHelpNew } from './assets/db-help-new.svg';
import { ReactComponent as DBHouse } from './assets/db-house.svg';
import { ReactComponent as DBLearningCenter } from './assets/db-learning-center.svg';
import { ReactComponent as DBPlay } from './assets/db-play.svg';
import { ReactComponent as DBRankings } from './assets/db-rankings.svg';
import { ReactComponent as DBSuggestContent } from './assets/db-suggest-content.svg';
import { ReactComponent as DBTeamManagement } from './assets/db-team-mgmt.svg';
import { ReactComponent as GlobalGo } from './assets/global-go.svg';
import { ReactComponent as GoalIcon } from './assets/goal-sm.svg';
import { ReactComponent as Message } from './assets/message.svg';

/** Icon slots the FIM navigation chrome renders. */
export interface NavIcons {
  home?: ReactNode;
  suggestContent?: ReactNode;
  assessment?: ReactNode;
  focus?: ReactNode;
  rankings?: ReactNode;
  teamManagement?: ReactNode;
  play?: ReactNode;
  preview?: ReactNode;
  learningCenter?: ReactNode;
  exploreGo?: ReactNode;
  store?: ReactNode;
  global?: ReactNode;
  goal?: ReactNode;
  award?: ReactNode;
  familyLink?: ReactNode;
  help?: ReactNode;
  message?: ReactNode;
  feedback?: ReactNode;
  menuUnfold?: ReactNode;
  menuFold?: ReactNode;
  caretDown?: ReactNode;
  caretDownDark?: ReactNode;
}

/** Built-in icon set used by the FIM navigation chrome. */
export const navIcons: NavIcons = {
  home: <DBHouse />,
  suggestContent: <DBSuggestContent />,
  assessment: <DBAssessment />,
  focus: <DBFocus />,
  rankings: <DBRankings />,
  teamManagement: <DBTeamManagement />,
  play: <DBPlay />,
  preview: <PreviewIcon />,
  learningCenter: <DBLearningCenter />,
  exploreGo: <GlobalGo />,
  store: <DBFIMStore />,
  global: <DBGlobal />,
  goal: <GoalIcon />,
  award: <DBAward />,
  familyLink: <FamilyLink />,
  help: <DBHelpNew />,
  message: <Message />,
  feedback: <FeedbackIcon />,
  menuUnfold: <MenuUnfoldOutlined />,
  menuFold: <MenuFoldOutlined />,
  caretDown: <CaretDown />,
  caretDownDark: <CaretDownDark />,
};
